import { useEffect, useState } from 'react'

import api from 'common/api'

type VisitsResponse = {
  Error: string
  Visits: VisitsData[]
}
export type VisitsData = {
  Id: string
  StartTime: string
  StartTimeZone: string
  EndTime: string
  EndTimeZone: string
  Virtual?: boolean
  ApprovalRequired?: boolean
  Participants?: {
    Scid: number
    SystemState: 'pending_state' | 'confirmed_state'
    Representatives: {
      RepId: string
      UserId: string
      SystemState: 'confirmed_state' | 'pending_state'
    }[]
  }[]
  HighSchoolName: string
  AllowRepLocation?: boolean
  Location?: {
    PlaceName?: string
    MeetingLink?: string
  }
  SystemState: 'open_state' | 'event_state' | 'partial_event_state'
  // UI Only
  VisitButton: 'register' | 'unregister' | 'request' | 'withdrawal'
  AllowRepLocationType?: boolean
}

export default function useGetCalendarVisitsData({
  highschoolId,
  refetch,
}: {
  highschoolId?: string
  refetch?: boolean
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isError, setIsError] = useState(false)
  const [data, setData] = useState<VisitsData[]>()
  const [error, setError] = useState<string>()

  useEffect(() => {
    async function fetchData(highschoolId: string) {
      setIsLoading(true)
      setIsSuccess(false)
      setIsError(false)
      setError(undefined)

      const params = new URLSearchParams({
        ids: highschoolId,
        startDate: new Date().toISOString(),
        endDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString(),
      })
      params.append('state', 'Draft')
      params.append('state', 'Open')
      params.append('state', 'Confirmed')

      const data = await api.get<VisitsResponse>(`/api/highschools/calendar/visits?${params}`)
      if (data.Error) {
        setIsError(true)
        setError(data.Error)
        setIsLoading(false)
        return
      }
      setData(data.Visits)
      setIsSuccess(true)
      setIsLoading(false)
    }

    if (highschoolId) {
      fetchData(highschoolId)
    }
  }, [highschoolId, refetch])

  return { isLoading, isSuccess, isError, error, data }
}
